import Container from "@/components/ui/Container";
import SectionHeader from "@/components/ui/SectionHeader";
import BulletList from "@/components/ui/BulletList";
import GradientCountBadge from "@/components/ui/icons/GradientCountBadge";

const dataSources = [
  {
    count: "30+",
    title: "Хосты и сервисы",
    bullets: ["инфраструктура и приложения", "связи между компонентами"],
  },
  {
    count: "40",
    title: "Производительность",
    bullets: ["нагрузка и отклик", "ключевые метрики"],
  },
  {
    count: "25+",
    title: "Проблемы",
    bullets: ["текущие и прошлые", "приоритет и влияние"],
  },
  {
    count: "20+",
    title: "События",
    bullets: [
      "изменения/активность системы",
      "действия пользователей и сервисов",
    ],
  },
  {
    count: "15+",
    title: "Логи",
    bullets: ["записи и сообщения", "разбор проблем"],
  },
  {
    count: "20+",
    title: "Пользовательский опыт",
    bullets: ["поведение и сегментация", "показатели скорости, сбои и ошибки"],
  },
  {
    count: "15+",
    title: "Приложения",
    bullets: ["мобильные и веб", "стабильность и загрузка"],
  },
  {
    count: "15+",
    title: "Настройки",
    bullets: ["конфигурация системы", "управление средой"],
  },
];

const bulletText = "text-[16px] font-medium leading-[1.3] text-[#202020]";

export default function DataSourcesSection() {
  return (
    <section className="rounded-[50px] bg-surface py-[60px] min-[478px]:py-[100px] xl:py-[120px]">
      <Container>
        <SectionHeader
          label="180+ инструментов"
          heading="Весь мониторинг в одном ответе"
        >
          <h3 className="mt-[30px] text-[21px] font-bold leading-none tracking-[-0.21px] text-[#1c3564]">
            Анализ строится на связях внутри системы
          </h3>
          <p className={`mt-4 max-w-[670px] ${bulletText}`}>
            MCP сопоставляет данные между собой и учитывает, как изменения в
            одной части системы влияют на другие: зависимости между сервисами,
            события и изменения, поведение пользователей, история деградаций,
            показатели стабильности (SLO)
          </p>
        </SectionHeader>

        <div className="mt-12 grid grid-cols-1 gap-2.5 min-[478px]:gap-5 sm:grid-cols-2 xl:mt-16 xl:grid-cols-4">
          {dataSources.map(({ count, title, bullets }) => (
            <div
              key={title}
              className="flex flex-col gap-6 rounded-[25px] bg-white p-[26px]"
            >
              <GradientCountBadge>{count}</GradientCountBadge>
              <h3 className="text-[21px] font-bold leading-none tracking-[-0.21px] text-[#1c3564]">
                {title}
              </h3>
              <BulletList
                spacing="space-y-0"
                className={bulletText}
                items={bullets}
              />
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
}
